export default __webpack_public_path__ + "static/media/exchange_api_v2.openapi.dd0beaa5.yaml";